import { useState } from "react";
import { CreateOrganizationForm } from "./create-organization-form.component";
import { ViewOrganizations } from "./view-organizations.component";
import "./organization-admin.view.css";

type OrganizationAdminMode = "create" | "view";

const MODE_OPTIONS: { id: OrganizationAdminMode; label: string }[] = [
  { id: "create", label: "Create organization" },
  { id: "view", label: "View organizations" },
];

export function OrganizationAdminView() {
  const [mode, setMode] = useState<OrganizationAdminMode>("create");

  return (
    <div className="organization-admin-view">
      <header className="org-admin-page-header">
        <div className="org-admin-toggle" role="tablist" aria-label="Organization admin views">
          {MODE_OPTIONS.map((option) => {
            const isActive = mode === option.id;
            return (
              <button
                key={option.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={
                  isActive
                    ? "org-admin-toggle-button active"
                    : "org-admin-toggle-button"
                }
                onClick={() => setMode(option.id)}
              >
                {option.label}
              </button>
            );
          })}
        </div>
      </header>

      {mode === "create" ? <CreateOrganizationForm /> : <ViewOrganizations />}
    </div>
  );
}
